import { render, staticRenderFns } from "./CoronaTest.vue?vue&type=template&id=3c429a32&"
import script from "./CoronaTest.vue?vue&type=script&lang=js&"
export * from "./CoronaTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports